/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NodeActionsEntity } from './NodeActionsEntity';
import {
    NodeActionsEntityFromJSON,
    NodeActionsEntityFromJSONTyped,
    NodeActionsEntityToJSON,
    NodeActionsEntityToJSONTyped,
} from './NodeActionsEntity';
import type { WorkflowProcessEntity } from './WorkflowProcessEntity';
import {
    WorkflowProcessEntityFromJSON,
    WorkflowProcessEntityFromJSONTyped,
    WorkflowProcessEntityToJSON,
    WorkflowProcessEntityToJSONTyped,
} from './WorkflowProcessEntity';

/**
 * 
 * @export
 * @interface ProcessWithNodeActionsEntity
 */
export interface ProcessWithNodeActionsEntity {
    /**
     * プロセス
     * @type {WorkflowProcessEntity}
     * @memberof ProcessWithNodeActionsEntity
     */
    process: WorkflowProcessEntity;
    /**
     * 権限を持っているノードと権限を持っているアクションの組み合わせ
     * @type {Array<NodeActionsEntity>}
     * @memberof ProcessWithNodeActionsEntity
     */
    nodeActions: Array<NodeActionsEntity>;
}

/**
 * Check if a given object implements the ProcessWithNodeActionsEntity interface.
 */
export function instanceOfProcessWithNodeActionsEntity(value: object): value is ProcessWithNodeActionsEntity {
    if (!('process' in value) || value['process'] === undefined) return false;
    if (!('nodeActions' in value) || value['nodeActions'] === undefined) return false;
    return true;
}

export function ProcessWithNodeActionsEntityFromJSON(json: any): ProcessWithNodeActionsEntity {
    return ProcessWithNodeActionsEntityFromJSONTyped(json, false);
}

export function ProcessWithNodeActionsEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProcessWithNodeActionsEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'process': WorkflowProcessEntityFromJSON(json['process']),
        'nodeActions': ((json['nodeActions'] as Array<any>).map(NodeActionsEntityFromJSON)),
    };
}

export function ProcessWithNodeActionsEntityToJSON(json: any): ProcessWithNodeActionsEntity {
    return ProcessWithNodeActionsEntityToJSONTyped(json, false);
}

export function ProcessWithNodeActionsEntityToJSONTyped(value?: ProcessWithNodeActionsEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'process': WorkflowProcessEntityToJSON(value['process']),
        'nodeActions': ((value['nodeActions'] as Array<any>).map(NodeActionsEntityToJSON)),
    };
}

